import React, { useCallback } from 'react';
import { FormControlLabel, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import StudioToolTip from '../../actions/StudioToolTip';
import SwitchAction from '../../actions/SwitchAction';
import {
  selectCameraRecording,
  selectCountdownCamera,
  selectIsPlayPrompter,
  selectTeleprompterSync
} from '../../../../store/modules/studio/selectors';
import { StudioControlStyles } from '../../styles';
import { setTeleprompterSync } from '../../../../store/modules/studio/actions';

export default function SyncTeleprompterAction() {
  const isTeleprompterSync = useSelector(selectTeleprompterSync);
  const isRecording = useSelector(selectCameraRecording);
  const isPrompterPlay = useSelector(selectIsPlayPrompter);
  const isCountdown = useSelector(selectCountdownCamera);
  const classes = StudioControlStyles();
  const dispatch = useDispatch();

  const switchTeleprompterSync = useCallback(() => {
    dispatch(setTeleprompterSync(!isTeleprompterSync));
  }, [dispatch, isTeleprompterSync]);

  return (
    <Grid item container className={classes.syncPrompterRoot}>
      <StudioToolTip title={"Teleprompter will play and pause based on recording"}>
        <Grid item>
          <FormControlLabel
            label="Sync teleprompter"
            labelPlacement="end"
            htmlFor="teleprompter-sync-switcher"
            classes={{
              root: classes.labelRoot,
              label: isRecording || isPrompterPlay || isCountdown ? classes.disabledSwitchLabel : classes.labelControl,
            }}
            control={(
              <SwitchAction
                id="teleprompter-sync-switcher"
                checked={isTeleprompterSync}
                value={isTeleprompterSync}
                onChange={switchTeleprompterSync}
                disabled={isRecording || isPrompterPlay || isCountdown}
                className={isRecording || isPrompterPlay || isCountdown ? classes.disabledSwitch : ''}
              />
            )}
            data-intercom-target="Switch: Sync Teleprompter"
          />
        </Grid>
      </StudioToolTip>
    </Grid>
  );
}
